import { render, staticRenderFns } from "./Cropfiveyearstrade.vue?vue&type=template&id=7436a967&scoped=true&"
import script from "./Cropfiveyearstrade.vue?vue&type=script&lang=js&"
export * from "./Cropfiveyearstrade.vue?vue&type=script&lang=js&"
import style0 from "./Cropfiveyearstrade.vue?vue&type=style&index=0&id=7436a967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7436a967",
  null
  
)

export default component.exports